import { render, staticRenderFns } from "./addgoodssalepay.vue?vue&type=template&id=588dc0c5&scoped=true&"
import script from "./addgoodssalepay.vue?vue&type=script&lang=js&"
export * from "./addgoodssalepay.vue?vue&type=script&lang=js&"
import style0 from "./addgoodssalepay.vue?vue&type=style&index=0&id=588dc0c5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588dc0c5",
  null
  
)

export default component.exports